import React from 'react';

export default function ConsagracionVirgen() {
  return (
    <>
        <p>
        Purísima Madre mía, quiero consagrarte mi corazón, mi voluntad, mi vida entera. <br/> Llévame al Corazón de tu Divino Hijo Jesús, para que El habite en mí. <br/> Quiero ser totalmente tuyo Madre mía y a partir de hoy, servirte fielmente en lo que me mandes. <br/> Sé dulce compañía en mi vida, no permitas que jamás me separe de Ti y en la hora de la muerte ven a buscarme para gozar de la eternidad en Tu compañía. <br/> Bendita y Alabada seas por siempre Madre Mía. <br/> <br/> Amén.
        </p>
    </>
  );
}
